/** Whether the AI chat widget is enabled for this build. */
export const isChatWidgetEnabled = import.meta.env.VITE_ENABLE_CHAT_WIDGET === 'true'

/**
 * Affiche la fiche de recherche vol (`FlightDraft`) en direct sous le chat.
 * La fiche transite déjà à chaque tour dans `clientState.flightModeState` : ce
 * drapeau ne fait que la RENDRE, il n'ajoute aucun aller-retour réseau.
 */
export const isChatDraftDebugEnabled =
  import.meta.env.DEV || import.meta.env.VITE_SHOW_CHAT_DRAFT_DEBUG === 'true'
